<section *ngIf="action && (actionDetails$ | async) as details">
  <span class="next-action-info--span">
    <b *ngIf="details.isResponsible; else notResponsible">
      <mat-icon>{{ details.icon || 'warning_amber' }}</mat-icon>
      {{ details.description }}
    </b>
    <ng-template #notResponsible>
      <mat-icon>info_outline</mat-icon>
      {{ details.description }}
    </ng-template>
  </span>
</section>
